export const routeList = {
    search: '/search',
    signup: '/signup',
    login: '/login',
    logout: '/logout',
    stores: '/stores',
    store: '/store',
    tree: '/tree',
    myPages: '/my-pages',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    preview: '/preview'
};
// This can be used to set defaults for shop.config.js
export function addMissingConfig(userConfig) {
    if (!userConfig.pathsWithNoAuthRequired) {
        userConfig.pathsWithNoAuthRequired = [
            '/login',
            '/reset-password',
            '/forgot-password'
        ];
    }
    if (!userConfig.loginPath) {
        userConfig.loginPath = '/login';
    }
    if (!userConfig.routes)
        userConfig.routes = {};
    Object.keys(routeList).forEach((key) => {
        if (!userConfig.routes.hasOwnProperty(key))
            userConfig.routes[key] = { path: routeList[key] };
    });
    return userConfig;
}
//# sourceMappingURL=addMissingConfig.js.map